import { PUBLIC_PATH } from '../../config/routes-config';
import { ReservationChannel } from '../../enums/reservation-channel.enum';
import { ReservationSource } from '../../enums/reservation-souce.enum';

const sourceLabels: Record<string, string> = {
  [ReservationSource.BN_ADMIN]: 'Admin',
  [ReservationSource.BN_APP]: 'BN App',
  [ReservationSource.BN_WEBSITE]: 'BN Website',
  [ReservationSource.CX]: 'CX',
  [ReservationSource.OFFLINE_SALES]: 'Offline Sales',
  [ReservationSource.ACQUISITION_TEAM]: 'Acquisition Team',
  [ReservationSource.PARTNERS]: 'Partners',
  [ReservationSource.CHANNEL_MANAGER]: 'Channel Manager'
};

const channelLabels: Record<string, string> = {
  [ReservationChannel.BIRDNEST]: 'Birdnest',
  [ReservationChannel.AIRBNB]: 'Airbnb',
  [ReservationChannel.BOOKING]: 'Booking',
  [ReservationChannel.EXPEDIA]: 'Expedia',
  [ReservationChannel.VRBO]: 'Vrbo',
  [ReservationChannel.CALL_CENTER]: 'Call Center',
  [ReservationChannel.WHATSAPP]: 'WhatsApp',
  [ReservationChannel.FACEBOOK]: 'Facebook',
  [ReservationChannel.INSTAGRAM]: 'Instagram',
  [ReservationChannel.REFERRAL]: 'Referral',
  [ReservationChannel.TMC]: 'TMC',
  [ReservationChannel.CORPORATE_ACCOUNTS]: 'Corporate Accounts',
  [ReservationChannel.BROKER]: 'Broker',
  [ReservationChannel.ACQUISITION_TEAM]: 'Acquisition Team',
  [ReservationChannel.BLUE_KEYS]: 'BlueKeys',
  [ReservationChannel.AHMED_ALI]: 'Ahmed Ali',
  Messenger: 'Messenger'
};

export const getReservationSourceLabel = (source?: ReservationSource | string) => {
  if (!source) return 'Unknown';
  return sourceLabels[source] || source;
};

export const getReservationChannelLabel = (channel?: ReservationChannel | string) => {
  if (!channel) return 'Birdnest';
  return channelLabels[channel] || channel;
};

export const getReservationSourceImage = (source?: ReservationSource | string) => {
  switch (source) {
    case ReservationSource.BN_ADMIN:
      return `${PUBLIC_PATH}/assets/jpeg/admin.webp`;
    case ReservationSource.BN_APP:
      return `${PUBLIC_PATH}/assets/pngs/bn-app.png`;
    case ReservationSource.BN_WEBSITE:
      return `${PUBLIC_PATH}/assets/pngs/bn-website.png`;
    case ReservationSource.CHANNEL_MANAGER:
      return `${PUBLIC_PATH}/assets/jpeg/rentals-united.jpeg`;
    case ReservationSource.OFFLINE_SALES:
      return `${PUBLIC_PATH}/assets/pngs/sales.png`;
    case ReservationSource.ACQUISITION_TEAM:
      return `${PUBLIC_PATH}/assets/pngs/acquisition-team.png`;
    case ReservationSource.CX:
      return `${PUBLIC_PATH}/assets/jpeg/cx.jpeg`;
    case ReservationSource.PARTNERS:
      return `${PUBLIC_PATH}/assets/jpeg/partner.jpeg`;
    default:
      return `${PUBLIC_PATH}/assets/pngs/question-mark.png`;
  }
};

export const getReservationChannelImage = (channel?: ReservationChannel | string) => {
  switch (channel) {
    case ReservationChannel.AIRBNB:
      return `${PUBLIC_PATH}/assets/pngs/airbnb.png`;
    case ReservationChannel.EXPEDIA:
      return `${PUBLIC_PATH}/assets/pngs/expedia.png`;
    case ReservationChannel.BOOKING:
      return `${PUBLIC_PATH}/assets/pngs/booking.png`;
    case ReservationChannel.VRBO:
      return `${PUBLIC_PATH}/assets/pngs/vrbo.png`;
    case ReservationChannel.WHATSAPP:
      return `${PUBLIC_PATH}/assets/pngs/whatsapp.png`;
    case ReservationChannel.CALL_CENTER:
      return `${PUBLIC_PATH}/assets/pngs/call-center.png`;
    case ReservationChannel.INSTAGRAM:
      return `${PUBLIC_PATH}/assets/pngs/instagram.png`;
    case ReservationChannel.REFERRAL:
      return `${PUBLIC_PATH}/assets/pngs/referral.png`;
    case 'Messenger':
      return `${PUBLIC_PATH}/assets/pngs/messenger.png`;
    case ReservationChannel.TMC:
      return `${PUBLIC_PATH}/assets/pngs/tmc.png`;
    case ReservationChannel.CORPORATE_ACCOUNTS:
      return `${PUBLIC_PATH}/assets/jpeg/corporate.jpg`;
    case ReservationChannel.BROKER:
      return `${PUBLIC_PATH}/assets/pngs/sales.png`;
    case ReservationChannel.ACQUISITION_TEAM:
      return `${PUBLIC_PATH}/assets/pngs/acquisition-team.png`;
    case ReservationChannel.BLUE_KEYS:
      return `${PUBLIC_PATH}/assets/pngs/blue_keys.png`;
    case ReservationChannel.FACEBOOK:
      return `${PUBLIC_PATH}/assets/jpeg/facebook.webp`;
    case ReservationChannel.AHMED_ALI:
      return `${PUBLIC_PATH}/assets/jpeg/partner.jpeg`;
    default:
      return `${PUBLIC_PATH}/assets/svgs/bird.svg`;
  }
};
